import { IFileStorage } from '@truvity/widget__forms';

import { EntityDid, WalletDid, WalletViewApi } from '../../../types';

export type ReadonlyFileApi = Pick<WalletViewApi, 'getPresignedDownloadUrlV1'>;

export class ReadonlyFilesStorage implements IFileStorage {
    constructor(
        private fileApi: ReadonlyFileApi,
        private walletDid: WalletDid,
        private entityDid: EntityDid,
    ) {}

    storeFile: IFileStorage['storeFile'] = async () => {
        throw new Error('Not implemented');
    };

    retreiveFile: IFileStorage['retreiveFile'] = async (formFile, _fieldName) => {
        const { DownloadUrl: downloadUrl } = await this.fileApi.getPresignedDownloadUrlV1(
            formFile.Url,
            this.walletDid,
            this.entityDid,
        );
        const response = await fetch(downloadUrl);
        const blob = await response.blob();
        return new File([blob], formFile.Name);
    };

    deleteFile: IFileStorage['deleteFile'] = async () => {
        throw new Error('Not implemented');
    };
}
